import { useCallback } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"

export type CreateStoreForDemoParams = {
  name: string
  email: string
  password: string
}

export type CreateStoreForDemoResponse = {
  store: {
    id: number
    name: string
    label: string
  }
}

export const useCreateStoreForDemo = () => {
  const { postWithToken } = useSmoothApi()

  const createStoreForDemo = useCallback(
    async (params: CreateStoreForDemoParams): Promise<CreateStoreForDemoResponse> => {
      const url = `${SMOOTH_LINE_API_URL}/base_api/smoother/stores/create_for_demo`
      const response = await postWithToken<CreateStoreForDemoResponse>(url, params)
      return response.data
    },
    [postWithToken]
  )

  return {
    createStoreForDemo,
  }
}
